exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1i80m3EdUAyhDNYIljPKMo{height:33px;font-size:14px;font-weight:400}", ""]);
// Exports
exports.locals = {
	"findPeopleControl": "_1i80m3EdUAyhDNYIljPKMo"
};